export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  CAD = 'CAD',
  HKD = 'HKD',
  SGD = 'SGD',
  CHF = 'CHF',
  JPY = 'JPY',
  SEK = 'SEK',
  DKK = 'DKK',
  NOK = 'NOK',
  BRL = 'BRL',
  INR = 'INR',
  CNY = 'CNY',
  ZAR = 'ZAR',
  AUD = 'AUD',
  THB = 'THB',
  PLN = 'PLN',
  KWH = 'KWH',
  CBM = 'CBM',
}
